import React, { useEffect, useRef, useState } from 'react'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import { FormControl } from '@mui/material'
import Select, { MultiValue } from 'react-select'
import { SelectChangeEvent } from '@mui/material/Select'
import { useSelector } from 'react-redux'
import { getRisquesByMissionId } from '../../redux/risques/risqueActions'
import { useAppDispatch, RootState, AppDispatch } from '../../redux/store'
import { t } from 'i18next'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'
import { createOptionProps } from '../../components/common/CreateOptionMenu'

interface SelectRisqueProps {
  value: string[]
  onChange: (event: SelectChangeEvent<string[]>) => void
  MissionId: string
  disablePortalMenu?: boolean
  onCreateNew?: (search: string) => void
  reloadKey?: number
}

const SelectRisque: React.FC<SelectRisqueProps> = ({
  value,
  onChange,
  MissionId,
  disablePortalMenu = false,
  onCreateNew,
  reloadKey = 0,
}) => {
  const menu = useExclusiveMenu(!disablePortalMenu)
  const dispatch: AppDispatch = useAppDispatch()
  const risquesList = useSelector((state: RootState) => state.risque.risques)

  const containerRef = useRef<HTMLDivElement | null>(null)
  const [optionsLoading, setOptionsLoading] = useState(false)


  useEffect(() => {
    if (!MissionId) {
      setOptionsLoading(false)
      return
    }
    let active = true
    setOptionsLoading(true)
    dispatch(getRisquesByMissionId(MissionId)).finally(() => {
      if (active) setOptionsLoading(false)
    })
    return () => {
      active = false
    }
  }, [dispatch, MissionId, reloadKey])

  const options = Array.isArray(risquesList)
    ? risquesList.map((risque) => ({
        value: risque._id || '',
        label: risque.RisqueName || '',
      }))
    : []

  const selectedOptions = options.filter((opt) => value?.includes(opt.value))

  const handleSelectChange = (
    selected: MultiValue<{ value: string; label: string }>
  ) => {
    onChange({
      target: { name: 'RisqueId', value: selected ? selected.map((s) => s.value) : [] },
    } as SelectChangeEvent<string[]>)
  }

  return (
    <div ref={containerRef} style={{ width: '100%', position: 'relative' }}>
      <FormControl fullWidth style={{ width: '100%' }}>
        <Select
          isMulti
          value={selectedOptions}
          onChange={handleSelectChange}
          options={options}
          isLoading={optionsLoading}
          placeholder={
            !MissionId
              ? t('actionImport.context.pickMissionFirst')
              : optionsLoading
                ? t('selectOptions.loading')
                : t('risks', 'Risks')
          }
          isDisabled={optionsLoading || !MissionId}
          noOptionsMessage={() =>
            !MissionId ? t('actionImport.context.pickMissionFirst') : t('tables.noData')
          }
          {...menu}
          styles={incyiaSelectStyles}
          {...createOptionProps(
            onCreateNew && MissionId
              ? { label: t('quickCreate.new.risk'), onCreate: onCreateNew }
              : undefined
          )}
        />
      </FormControl>
    </div>
  )
}

export default SelectRisque
